// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBbtKAF7D2yOISge4ywKmhH0Cd_6l719l4",
    authDomain: "rpdavps.firebaseapp.com",
    databaseURL: "https://rpdavps-default-rtdb.firebaseio.com",
    projectId: "rpdavps",
    storageBucket: "rpdavps.appspot.com",
    messagingSenderId: "546062426248",
    appId: "1:546062426248:web:b4fbe392e4021d601f3f3d",
    measurementId: "G-4KRSPMC13E"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
